import styled from 'styled-components';

/* Main blocks */
export const StyledBadgeContainer = styled.div`
  display: inline-block;
  background: ${({ theme }) => theme.colors.palette[2]};
  border-radius: 3px;
  text-align: center;
  vertical-align: middle;
  line-height: 14px;
  padding: 0px 5px;
  margin: ${({ position }) => position === 'before' ? '0 5px 0 0' : '0 0 0 5px'};
`;

export const StyledBadgeText = styled.div`
  display: inline;
  color: white;
  font-weight: bold;
  letter-spacing: 0.1em;
  font-size: 6px;
  text-transform: uppercase;
`;

/* 'New' Badge (such as in Navigation) */
export const NewItemBadgeContainer = styled(StyledBadgeContainer)`
  background: white;
  line-height: unset;

  ${StyledBadgeText} {
    text-transform: capitalize;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.palette[3]};
  }
`;

/* User Entity 'You' Badge */
export const UserEntityBadgeContainer = styled(StyledBadgeContainer)`
    background: ${({ theme }) => theme.colors.palette[2]};
`;
